import { render, staticRenderFns } from "./FareFamilyService.vue?vue&type=template&id=457a5e95&scoped=true&"
import script from "./FareFamilyService.vue?vue&type=script&lang=js&"
export * from "./FareFamilyService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457a5e95",
  null
  
)

export default component.exports